// @ts-nocheck
import { Enveloper } from "./enveloper.js";
import { getBit, setBit } from "../helpers/binary-helpers.js";
import { PolynomialRegister } from "./registers/sound-4-polynomial-register.js";
import { EnvelopeControlRegister } from "./registers/envelope-control-registers.js";
import { ContinuousSelectionRegister } from "./registers/continuous-selection-register.js";
import { SimpleByteRegister } from "../helpers/simple-byte-register.js";
export class Sound4 {
    frequencyTimer = 0;
    frequencyPeriod = 0;
    lengthTimer = 0;
    enveloper = new Enveloper();
    volume = 0;
    linearFeedbackShift = 0;
    nr41Length = new SimpleByteRegister(0xff20);
    nr42EnvelopeControl = new EnvelopeControlRegister(0xff21);
    nr43Polynomial = new PolynomialRegister(0xff22);
    nr44ContinuousSelection = new ContinuousSelectionRegister(0xff23);
    isActive = false;
    // Live channel-on status for NR52 ($FF26) bit 3. See Sound1.isOn.
    get isOn() {
        return this.isActive;
    }
    writeNr44(value) {
        this.nr44ContinuousSelection.value = value;
        if ((value & 0x80) !== 0) {
            this.playSound();
        }
    }
    // NR42 ($FF21) write. A DAC-disabling value (top 5 bits clear) disables the
    // channel so NR52's status bit reflects it. See Sound1.writeNr12.
    writeNr42(value) {
        this.nr42EnvelopeControl.value = value;
        if (!this.nr42EnvelopeControl.isDacEnabled) {
            this.isActive = false;
        }
    }
    // Power-off clears every channel register and silences the channel.
    powerOff() {
        this.isActive = false;
        this.nr41Length.value = 0;
        this.nr42EnvelopeControl.value = 0;
        this.nr43Polynomial.value = 0;
        this.nr44ContinuousSelection.value = 0;
    }
    tick(cycles) {
        this.frequencyTimer -= cycles; // count down the frequency timer
        if (this.frequencyTimer <= 0) {
            this.frequencyTimer = this.getFrequencyPeriod(); // reload timer with the current frequency period
            this.stepLinearFeedbackShift();
        }
    }
    getFrequencyPeriod() {
        return this.nr43Polynomial.divisor << this.nr43Polynomial.clockShift;
    }
    playSound() {
        // Enable channel
        this.isActive = true;
        // Initialize frequency
        this.linearFeedbackShift = 0x7fff;
        this.frequencyPeriod = this.getFrequencyPeriod();
        this.frequencyTimer = this.frequencyPeriod;
        // Initialize envelope
        this.volume = this.nr42EnvelopeControl.initialVolume;
        this.enveloper.initializeTimer(this.nr42EnvelopeControl.lengthOfEnvelopeStep);
        // Initialize length
        this.lengthTimer = 64 - (this.nr41Length.value & 0b111111);
        // A trigger with the DAC off does not enable the channel.
        if (!this.nr42EnvelopeControl.isDacEnabled) {
            this.isActive = false;
        }
    }
    clockLength() {
        if (!this.nr44ContinuousSelection.isContinuousSelection) {
            this.lengthTimer--;
            if (this.lengthTimer === 0) {
                this.isActive = false;
            }
        }
    }
    clockVolume() {
        this.volume = this.enveloper.clockVolume(this.volume, this.nr42EnvelopeControl);
    }
    stepLinearFeedbackShift() {
        const bit0 = getBit(this.linearFeedbackShift, 0);
        const bit1 = getBit(this.linearFeedbackShift, 1);
        const result = bit1 ^ bit0;
        this.linearFeedbackShift >>= 1;
        this.linearFeedbackShift = setBit(this.linearFeedbackShift, 14, result);
        if (this.nr43Polynomial.counterWidth === 7) {
            this.linearFeedbackShift = setBit(this.linearFeedbackShift, 6, result);
        }
    }
    getSample() {
        if (!this.nr42EnvelopeControl.isDacEnabled || !this.isActive) {
            return 0;
        }
        const sample = ~(this.linearFeedbackShift) & 0b1;
        const volumeAdjustedSample = sample * this.volume;
        return volumeAdjustedSample / 15;
    }
}
//# sourceMappingURL=sound-4.js.map